import Vue from "vue";
import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";
import store from "../../store/index.js";
import { i18n } from "../../main.js";
import {
  validatePasswordMinCharacters,
  validatePasswordMinLowerCase,
  validatePasswordMinNumbers,
  validatePasswordMinSpecialCharacters,
  validatePasswordMinUpperCase,
} from "../../utils/index.js";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$pessoas_usuarios = new Vue({
  data() {
    return {
      ENDPOINTS,
      access_token: false,
      modalAlertSucesso: false,
      usuarioAddEdit: "new",
      logado: false,
      usuarios_loading: false,
      recovery_loading: false,
      cookies: false,
      menu: {
        show: false,
        loading: false,
      },
      user: {
        avatar: "",
        nome: "",
        email: "",
        senha: "",
        show_senha: false,
        senha2: "",
        show_senha2: false,
        old_password: "",
        show_old_pass: false,
        mfa: "",
        error: {
          nome: [],
          email: [],
          old_password: [],
          senha: [],
          senha2: [],
        },
      },
      cadastro: {
        iduser: "",
        avatar: { imagem: null },
        nome: "",
        email: "",
        senha: "",
        loading: false,
        perfil: [],
        status: "",
        bloqueado: false,
        error: {
          nome: [],
          email: [],
          email2: [],
          perfil: [],
          old_password: [],
          senha: [],
          senha2: [],
          status: [],
        },
      },
      usuarios: [],
      filtros: [],
      filter: {
        nome: "",
        email: "",
        status: "",
        dataInicio: "",
        dataFim: "",
        nidperfil: "",
      },
      qr_code: "",
      send_mfa: false,
    };
  },
  methods: {
    // ...mapActions(["setUserType"]),
    /**
     * @description Método para fazer login
     * @param {String} user Email do usuário
     * @param {String} senha Senha do usuário
     * @return {Promise} Retorna uma promise com o resultado da requisição
     */
    async getLogin(login, user, senha, token, mfa) {
      if (login) {
        let recaptcha = "";
        if (process.env.NODE_ENV === "production") {
          recaptcha = await window.grecaptcha.getResponse();
        }
        this.cadastro.loading = true;
        this.$axios
          .post(
            this.ENDPOINTS.LOGIN,
            JSON.stringify({
              email: user,
              senha: senha,
              captcha: recaptcha,
              mfa,
            })
          )
          .then(response => {
            if (response && response?.code === 7500) {
              this.$config.alert(
                i18n.t("common.password-requirements.reset-password"),
                this.$config.dados.errorColor
              );
              router.push(`/recuperar-senha-admin?${response.params}`);
            }

            if (response && response?.code === 7700) {
              this.qr_code = response.qr_code;
            }

            if (response && response?.code === 7600) {
              this.send_mfa = true;
            }

            if (response && response.access_token) {
              this.send_mfa = false;
              this.qr_code = "";
              let dados = response.info;
              this.$config.user_type = dados?.user_type;
              this.logado = true;
              this.$axios.setCookie("oe_jwt", response.access_token);
              this.$axios.setLocal("oe_user_info", dados);
              store.dispatch("setUserType", dados?.user_type);
              store.dispatch("setUserInfo", dados);

              router.push("/home");
            }
            this.cadastro.loading = false;
          })
          .catch(() => {
            this.cadastro.loading = false;
          })
          .finally(() => {
            if (process.env.NODE_ENV === "production") {
              window.grecaptcha.reset();
            }
          });
      } else {
        this.$axios
          .post(this.ENDPOINTS.LOGIN, JSON.stringify({ token_acesso: token }))
          .then(response => {
            let dados = response.info;
            this.$axios.setLocal("oe_user_info", dados);
            this.user.avatar = dados.avatar;
            this.user.nome = dados.nome;
            this.user.email = dados.email;
          })
          .catch(error => {
            throw new Error(error);
          });
      }
    },

    /**
     * @description Método que buscar os usuários
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getUsuarios() {
      this.usuarios_loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_USUARIOS).then(response => {
        if (response) {
          this.usuarios = response;
          this.usuarios_loading = false;
        }
      });
    },

    /**
     * @description Método para desabilitar usuário
     * @param {String} idusuario - ID do usuário
     * @param {String} status - Status inativo
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    desabilitarUsuario(idusuario) {
      this.$axios
        .put(this.ENDPOINTS.DESABILITAR_USUARIO + idusuario)
        .then(response => {
          if (response) {
            this.getUsuarios();
          }
        });
    },

    /**
     * @description Método para habilitar usuário
     * @param {String} idusuario - ID do usuário
     * @param {String} status - Status ativo
     * @return {Promise} Retorna uma promise com o resultado da requisição
     */
    habilitarUsuario(idusuario) {
      this.$axios
        .put(this.ENDPOINTS.HABILITAR_USUARIO + idusuario, { status: "ATIVO" })
        .then(response => {
          if (response) {
            this.getUsuarios();
          }
        });
    },

    /**
     * @description Método para alterar as informações do usuário
     * @param {String} idusuario - ID do usuário
     * @param {Object} dados - Dados do usuário
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    alterarUsuario() {
      this.cadastro.loading = true;
      let idusuario = this.cadastro.iduser;
      let dados = {
        avatar: this.cadastro.avatar.imagem,
        nome: this.cadastro.nome,
        email: this.cadastro.email,
        status: this.cadastro.status,
        bloqueado: this.cadastro.bloqueado,
        nidperfil: this.cadastro.perfil.join(";"),
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_USUARIO + idusuario, dados)
        .then(() => {
          this.$axios.setLocal("confirmEdit", true);
          router.push("/pessoas/usuarios");
          this.$pessoas_usuarios.limpaFormularioDeUsuario(),
            (this.cadastro.loading = false),
            (this.cadastro.perfil = []),
            (this.cadastro.error.nome = []),
            (this.cadastro.error.email = []);
          this.usuarioAddEdit = "";
          this.cadastro.loading = false;
          this.getLogin(false, "", "", this.$axios.getCookie("token").data);
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para cadastrar um novo usuário
     * @param {Object} dados - Dados do usuário
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    async cadastrarUsuario() {
      this.cadastro.loading = true;
      let dados = {
        avatar: this.cadastro.avatar.imagem,
        nome: this.cadastro.nome,
        email: this.cadastro.email,
        senha: this.cadastro.senha,
        status: this.cadastro.status,
        bloqueado: this.cadastro.bloqueado,
        nidperfil: this.cadastro.perfil.join(";"),
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_USUARIO, dados)
        .then(response => {
          if (response) {
            this.$pessoas_usuarios.limpaFormularioDeUsuario(),
              (this.cadastro.loading = false),
              (this.cadastro.perfil = []),
              (this.cadastro.error.nome = []),
              (this.cadastro.error.email = []);
            this.usuarioAddEdit = "";
            router.push("/pessoas/usuarios");
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para trocar a senha do usuário
     * @param {String} idusuario - ID do usuário
     * @param {String} old_password - Senha antiga do usuário
     * @param {String} senha - Senha nova do usuário
     * @param {String} senha2 - Senha nova de confirmação do usuário
     * @param {Boolean} show_old_pass - Variável para mostrar senha antiga
     * @param {Boolean} show_senha - Variável para mostrar senha
     * @param {Boolean} show_senha2 - Variável para mostrar senha de confirmação
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    async trocarSenha() {
      let idusuario = this.$axios.getLocal("oe_user_info")?.data?.idusuario;
      this.$axios.getCookie("oe_jwt");
      if (this.user.old_password.length == 0) {
        this.$config.alert(
          "Insira sua senha atual!",
          this.$config.dados.errorColor
        );
        this.$pessoas_usuarios.user.error.old_password =
          "Insira sua senha atual";
        return;
      }
      if (this.user.senha != this.user.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        this.$pessoas_usuarios.user.error.senha2 =
          "As senhas são incompatíveis!";
        return;
      }
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_SENHA + idusuario,
          JSON.stringify({
            senha_antiga: this.user.old_password,
            senha_nova: this.user.senha,
          })
        )
        .then(response => {
          if (response) {
            localStorage.removeItem("token");
            this.$axios.destroy(true);
            this.user.old_password = "";
            this.user.show_old_pass = "password";
            this.user.senha = "";
            this.user.show_senha = "password";
            this.user.senha2 = "";
            this.user.show_senha2 = "password";
            if (location.pathname != "login") {
              setTimeout(() => {
                router.push("/");
              }, 3000);
            }
          }
        });
    },

    /**
     * @description Método para filtrar usuários
     * @param {Array} filtros - Array com os filtros
     * @param {Object} filter - Objeto com as opções de filtros
     * @returns {Array} - Array com os usuários filtrados
     */
    filtroUsuarios() {
      this.filtros = [];
      this.usuarios_loading = true;
      if (this.filter.nome != "") {
        this.filtros.push({
          campo: "nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }

      if (this.filter.email != "") {
        this.filtros.push({
          campo: "email",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.email,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: this.filter.dataInicio + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: this.filter.dataFim + " 23:59",
        });
      }

      if (this.filter.nidperfil != "") {
        this.filtros.push({
          campo: "nidperfil",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nidperfil,
        });
      }

      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_USUARIOS,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.usuarios = response;
          this.usuarios_loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para validar cadastro de usuário
     * @returns {Function} - Retorna uma função Altrerar ou Cadastrar usuário
     */
    async validarCadastro() {
      if (this.cadastro.nome.length < 2 || this.cadastro.nome == "") {
        this.$config.alert(
          i18n.t("people.users.name-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.nome = i18n.t("people.users.name-error");
        return;
      }

      if (this.cadastro.email.length < 2 || this.cadastro.email == "") {
        this.$config.alert(
          i18n.t("people.users.email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("people.users.email-error");
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.email)) {
        this.$config.alert(
          i18n.t("people.users.invalid-email-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.email = i18n.t("people.users.invalid-email-error");
        return;
      }

      if (this.usuarioAddEdit == "new") {
        const password = this.cadastro.senha;

        if (validatePasswordMinCharacters(password)) {
          this.$config.alert(
            i18n.t("common.password-requirements.error-messages.min-length"),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-length"
          );
          return;
        }

        if (validatePasswordMinNumbers(password)) {
          this.$config.alert(
            i18n.t("common.password-requirements.error-messages.min-numbers"),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-numbers"
          );
          return;
        }

        if (validatePasswordMinLowerCase(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-non-capital-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-non-capital-characters"
          );
          return;
        }

        if (validatePasswordMinUpperCase(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-capital-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-capital-characters"
          );
          return;
        }

        if (validatePasswordMinSpecialCharacters(password)) {
          this.$config.alert(
            i18n.t(
              "common.password-requirements.error-messages.min-special-characters"
            ),
            this.$config.dados.errorColor
          );
          this.cadastro.error.senha = i18n.t(
            "common.password-requirements.min-special-characters"
          );
          return;
        }
      }

      if (this.cadastro.status === "") {
        this.$config.alert(
          i18n.t("people.users.status-error"),
          this.$config.dados.errorColor
        );
        this.cadastro.error.status = i18n.t("people.users.status-error");
        return;
      }

      // if(this.cadastro.perfil.length < 1)
      //     { this.$config.alert('Selecione ao menos um perfil para o usuário!', this.$config.dados.errorColor); return }

      if (this.usuarioAddEdit == "editar") {
        this.alterarUsuario();
        return;
      }

      this.cadastrarUsuario();
    },

    async recuperarSenha(email) {
      let recaptcha = "";
      if (process.env.NODE_ENV === "production") {
        recaptcha = await window.grecaptcha.getResponse();
      }
      if (recaptcha == "" && process.env.NODE_ENV === "production") {
        window.grecaptcha.reset();
        return;
      }

      this.recovery_loading = true;

      let dados = {
        email: email,
        url: process.env.VUE_APP_PANEL_URL + "recuperar-senha-admin",
        captcha: recaptcha,
      };

      this.$axios
        .post(this.ENDPOINTS.EMAIL_RECUPERAR_SENHA, dados)
        .then(response => {
          this.recovery_loading = false;
          window.grecaptcha.reset();
          if (response && response.sucesso) {
            document.getElementsByClassName(
              "modal-body-esqueci-senha"
            )[0].style.display = "none";
            return;
          }
        })
        .catch(() => {
          this.recovery_loading = false;
          if (process.env.NODE_ENV === "production") {
            window.grecaptcha.reset();
          }
        });
    },

    recoverySenha(dados) {
      this.recovery_loading = true;
      this.$axios
        .put(this.ENDPOINTS.RECUPERAR_SENHA_ADMIN, dados)
        .then(response => {
          if (response) {
            this.recovery_loading = false;
            router.push("/");
          }
        })
        .catch(error => {
          this.recovery_loading = false;
          throw new Error(error);
        });
    },

    limpaFormularioDeUsuario() {
      this.cadastro.nome = "";
      this.cadastro.email = "";
      this.cadastro.senha = "";
      this.cadastro.status = "ATIVO";
      this.cadastro.avatar.imagem = null;
      delete this.cadastro.avatar.object;
    },

    limpaFilterDeUsuario() {
      this.filter.nome = "";
      this.filter.email = "";
      this.filter.status = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.filter.nidperfil = "";
    },
  },
});
